import axios from 'axios';
import config from "../config";
import { clearStoredAuthSession } from "./authSession";

const apiClient = axios.create({
    // baseURL: 'http://localhost:4567/api',
    baseURL: `${config.APP_URL}/api`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['Accept'] = 'application/json';

            if (config.method === 'post') {
                if (config.data instanceof FormData) {
                    delete config.headers['Content-Type'];
                    if (config.data.has?.('token')) config.data.delete('token');
                    config.data.append('token', token);
                } else {
                    config.data = { ...(config.data || {}), token };
                }
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    async (response) => {
        // Check if the backend says "Please login to proceed"
        if ( response.data && response.data.success === false && response.data.data === 'Please login to proceed' ) {
            const originalRequest = response.config;
            const requestUrl = originalRequest?.url || "";

            if (requestUrl.includes('/issue-web-login-ticket') || requestUrl.includes('/consume-web-login-ticket')) {
                return response;
            }

            clearStoredAuthSession("backend-login-required");
        }
        return response;
    },
    (error) => Promise.reject(error)
);

export const fetchBangladeshList = async () => {
    try {
        const response = await apiClient.get('/get-bangladesh-currency-rate');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

// Fetch bank list with caching
export const fetchBankList = async () => {
    try {
        const response = await apiClient.get('/bank-list');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchDepositChannelList = async () => {
    try {
        const response = await apiClient.get('/deposit-channel-list');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchPaymentGatewayList = async () => {
    try {
        const response = await apiClient.get('/get-payment-gateway');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchPaymentGatewayStatus = async (sourceId) => {
    try {
        const form = new FormData();
        form.append('source_id', sourceId);

        const response = await apiClient.post('/payment-gateway-status', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchDepositBankDetailList = async () => {
    try {
        const response = await apiClient.get('/company-bank-list');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchGameCategoryList = async () => {
    try {
        const response = await apiClient.get('/get-game-category');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchBannerList = async () => {
    try {
        const response = await apiClient.get('/get-banner');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchLanguageList = async () => {
    try {
        const response = await apiClient.get('/get-language');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchReferralRebateList = async () => {
    try {
        const response = await apiClient.get('/get-referral-cashback');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchCurrencyRate = async () => {
    try {
        const response = await apiClient.get('/get-currency-rate');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

//post
export const fetchCryptoList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-crypto-details', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchCashBackList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-cashback', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchRebateList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-rebate', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchPaymentGatewayLink = async (params) => {
    try {
        let sourceId, bankCode, paymentMethod
        const timestamp = Date.now();

        if (params.gateway?.name === 'Andapay') {
            switch (params.gateway.channel_name) {
                case 'Payment Gateway':
                    sourceId = 'DP' + params.user?.id + timestamp.toString();
                    bankCode = params?.bank?.name;
                    paymentMethod = 'Bank'
                    break;
                case 'QRpay':
                    sourceId = 'QR' + params.user?.id + timestamp.toString();
                    bankCode = 'DANAQR'
                    paymentMethod = 'QR'
                    break;
                case 'QRis':
                    sourceId = 'QR' + params.user?.id + timestamp.toString();
                    bankCode = 'QRIS'
                    paymentMethod = 'QR'
                    break;
                default:
                    break;
            }
        } else if (params.gateway?.name === 'TrustPay') {
            sourceId = 'TP' + params.user?.id + timestamp.toString();
            bankCode = params?.bank?.deposit_number
            paymentMethod = params?.bank?.deposit_method
        }

        if (!sourceId || !bankCode || !paymentMethod) {
            throw new Error('Invalid payment gateway params');
        }

        const form = new FormData(); 
        form.append('source_id', sourceId);
        form.append('amount', params.amount.toString());
        form.append('bank_code', bankCode);
        form.append('payment_method', paymentMethod);
        form.append('payment_gateway_id', params.gateway.id);
        form.append('type', 'deposit');

        if (params.promotion && params.promotion !== 'skip' && params.gateway.channel_name === 'Payment Gateway') {
            form.append('promotion_id', params?.promotion?.id);
        }

        const response = await apiClient.post('/process-payment-gateway', form);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const sendInvoice = async (params) => {
    try {
        const form = new FormData();
        form.append('source_id', params.sourceId);
        form.append('payment_method', params.paymentMethod);
        form.append('bank_code', params.bankCode);
        form.append('amount', params.amount);
        form.append('mcode', params.mcode);
        form.append('type', params.type);
        if (params.paymentGatewayId) {
            form.append('payment_gateway_id', params.paymentGatewayId);
        }
        if (params.accountHolderName) {
            form.append('accountHolderName', params.accountHolderName);
        }
        if (params.accountNumber) {
            form.append('accountNumber', params.accountNumber);
        }
        if (params.currenciesSupported) {
            form.append('currencies_supported', params.currenciesSupported);
        }
        if (params.promotion && params.promotion !== 'skip') {
            form.append('promotion_id', params.promotion.id);
        }
        const response = await apiClient.post('/process-payment-gateway', form);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
            return error.response.data;
        }
        throw error;
    }
};

export const sendTransfer = async (params) => {
    try {
        const form = new FormData();
        form.append('mcode', params.mcode);
        form.append('sourceId', params.sourceId);
        form.append('amount', params.amount);
        form.append('bankCode', params.bankCode);
        form.append('accountHolderName', params.accountHolderName);
        form.append('accountNumber', params.accountNumber);
        form.append('currencies_supported', params.currenciesSupported || 'IDR');
        form.append('paymentMethod', params.paymentMethod || 'BANK');

        const response = await apiClient.post('/sendTransfer', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchDepositPromotionList = async (params) => {
    try {
        const form = new FormData(); 

        form.append('category', params);
        const response = await apiClient.post('/get-promotion', form);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const fetchBalance = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-balance', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const login = async (params) => {
    try {
        if (!params?.phoneNumber || !params?.password) {
            throw new Error('Missing login credentials');
        }

        const form = new FormData(); 
        form.append('username', params.phoneNumber);
        form.append('password', params.password);
        if(params.telegram_id) {
            form.append('telegram_id', params.telegram_id);
        }
        const response = await apiClient.post('/login', form);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const forgotPassword = async (params) => {
    try {
        if (!params?.phoneNumber) {
            throw new Error('Missing phone number');
        }

        const form = new FormData();
        form.append('username', params.phoneNumber);
        if (params.languageId) {
            form.append('language_id', params.languageId);
        }

        const response = await apiClient.post('/forgot-password', form);
        return response.data;
    } catch (error) {
        console.error('Error sending password reset email:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchGameList = async (params) => {
    try {
        const form = new FormData(); 
        form.append('category', params.category);
        const response = await apiClient.post('/game-list', form);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const launchGame = async (params) => {
    try {
        const form = new FormData(); 
        form.append('code', params);
        const response = await apiClient.post('/launch-game', form);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const processBankTransferDeposit = async (params) => {
    try {
        const form = new FormData();
        form.append('amount', params.amount);
        form.append('channel_id', 21);
        form.append('bank_account_id', params.bank.id);
        if (params.promotion && params.promotion !== 'skip') {
            form.append('promotion_id', params.promotion.id);
        }
        if (params.receipt !== 'skip') {
            form.append('receipt_path', params.receipt, params.receipt.name);
        }

        const response = await apiClient.post('/deposit', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const fetchUserTransactionHistory = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-user-transaction-history', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const withdraw = async (params) => {
    try {
        const form = new FormData();
        form.append('amount', params.amount);

        if (params.address) {
            form.append('address', params.address);
        }

        if (params.network) {
            form.append('network', params.network);
        }
        
        if (params.rate) {
            form.append('rate', params.rate);
        }

        const response = await apiClient.post('/withdraw', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const checkUserExist = async (params) => {
    try {
        const form = new FormData();
        form.append('password', params.password);

        const response = await apiClient.post('/check-phone', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const register = async (params) => {
    try {
        const form = new FormData();

        const languageMap = {
            'en': 1,
            'cn': 2,
            'id': 4
        };

        // const languageId = languageMap[params.language] || 1;
        const languageId = 4;

        form.append('skip', true);
        form.append('contact_no', params.phone_number);
        if (params.telegram_id) {
            form.append('telegram_id', params.telegram_id);
        }
        form.append('password', params.password);
        if (params.email) {
            form.append('email', params.email);
        }
        form.append('language_id', languageId);

        if (params.referral_code) {
            form.append('referral_code', params.referral_code);
        }

        const response = await apiClient.post('/register', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const fetchReferralLink = async () => {
    try {
        const endpoint =
            typeof window !== 'undefined' && window.Telegram?.WebApp?.initData
                ? '/get-mini-app-referral-link'
                : '/get-referral-link';

        const response = await apiClient.post(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const issueWebLoginTicket = async () => {
    try {
        const response = await apiClient.post('/issue-web-login-ticket');
        return response.data;
    } catch (error) {
        console.error('Error issuing web login ticket:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const consumeWebLoginTicket = async (ticket) => {
    try {
        const response = await apiClient.post('/consume-web-login-ticket', { ticket });
        return response.data;
    } catch (error) {
        console.error('Error consuming web login ticket:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const setWebPassword = async (params) => {
    try {
        const form = new FormData();
        form.append('password', params.password);
        form.append('confirm_password', params.confirmPassword);

        const response = await apiClient.post('/set-web-password', form);
        return response.data;
    } catch (error) {
        console.error('Error setting web password:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchPromotionContent = async (params = {}) => {
    try {
        const form = new FormData();
        if (params.language_id != null) {
            form.append('language_id', String(params.language_id));
        }

        const response = await apiClient.post('/get-promotion-content', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const updateUserLanguage = async (params) => {
    try {
        const form = new FormData();
        form.append('language_id', params);

        const response = await apiClient.post('/update-user-language', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchUserBankList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-bank-account', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchUserBankAccountDetailList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-bank-account-detail', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const updateUserBankDetails = async (params) => {
    try {
        const form = new FormData();
        form.append('bank', params.bank.id);
        form.append('bank_acc_no', params.user_bank.accountNumber);
        form.append('full_name', params.user_bank.accountName);

        const response = await apiClient.post('/update-user-bank-details', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchReferralCommissionList = async () => {
    try {
        const response = await apiClient.post('/get-referral-comm');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchReferralEarned = async () => {
    try {
        const response = await apiClient.post('/get-referral-earned');
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const updateTRCDeposit = async (params) => {
    try {
        const form = new FormData();
        if (params.promotion && params.promotion !== 'skip') {
            form.append('promotion_id', params.promotion.id);
        }

        if (params.amount) {
            form.append('amount', params.amount);
        }

        const response = await apiClient.post('/update-trc-deposit', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchReceiverAddressList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-receiver-address', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const fetchCryptoPendingList = async () => {
    try {
        const form = new FormData(); 

        const response = await apiClient.post('/get-crypto-pending', form);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
            console.error('Response:', error.response.data);
        }
        throw error;
    }
};

export const updateTRCStatus = async () => {
    try {
        const form = new FormData(); 
        const response = await apiClient.post('/update-trc-status', form);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
